module.exports = __webpack_public_path__ + "img/ico_biaoqiajunshi.71b0218d.png";